define('behavior/navigate.on.tab.press.behavior',['require','exports','module','underscore','marionette','backbone.radio','fukit','appkit/util/key.prefixer'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      Mn          = require('marionette'),
      Radio       = require('backbone.radio'),
      RouteHelper = require('fukit').RouteHelper,
      KeyPrefixer = require('appkit/util/key.prefixer');

  var NavigateOnTabPressBehavior = Mn.Behavior.extend({
    defaults: {
      routeName: 'default',
      routeParams: { id: '@model.id' },
      trigger: true,
      replace: false,
      model: null,
    },

    onFirstBeforeRender: function() {
      this.listenTo(this.view, 'childview:tab:route:resolve', function(tabContentView, tabItemView) {
        if (!tabItemView.getOption('active')) {
          this.routeName = this.resolveOption(tabItemView, 'routeName');
          this.routeParams = this.resolveOption(tabItemView, 'routeParams');
          this.trigger = this.resolveOption(tabItemView, 'trigger');
          this.replace = this.resolveOption(tabItemView, 'replace');

          this.navigate();
        }
      });
    },

    navigate: function() {
      var params = this.resolveRouteParams(this.routeParams);

      RouteHelper.navigate(this.routeName, params, { trigger: this.trigger, replace: this.replace });
    },

    resolveOption: function(tab, optionName) {
      return tab.getOption(optionName) || this.getOption(optionName);
    },

    resolveRouteParams: function(params) {
      var state = Radio.channel('AppKit.controllerService').request('state');
      var model = this.getOption('model') || this.view.model;
      var resolvedParams = {};

      _.each(
        params,
        function(param, key) {
          var resolvedFunctionParam = Mn._getValue(param, this);
          resolvedParams[key] = resolvedFunctionParam;
        },
        this
      );

      return KeyPrefixer.resolve(resolvedParams, {
        '@state.': function(stateKey) {
          if (state) {
            return state.get(stateKey);
          }
        },
        '@model.': function(modelKey) {
          if (model) {
            return model.get(modelKey);
          }
        },
      });
    },
  });
  module.exports = NavigateOnTabPressBehavior;
});

